window.app = window.app || {};

window.app.productReviews = {
  el: {
    sectionHeader: document.querySelector('.mt-reviews__heading'),
    wrapper: document.querySelector('.mt-reviews__carousel'),
    carousel: document.querySelector('.mt-reviews__carousel .swiper'),
    arrows: document.querySelectorAll('.mt-reviews__carousel-arrow'),
    seeMore: document.querySelectorAll('.mt-review__see-more:not(.initialized)'),
    loadMoreWrapper: document.querySelector('.mt-reviews__carousel-summary'),
    loadMore: document.querySelector('.mt-reviews__carousel-lmb')
  },

  init: function() {
    const _this = this;
    if (!_this.el.carousel || !_this.el.wrapper) return;
    
    isCarousel = (_this.el.wrapper.dataset.type == 'carousel');
    const carouselConfig = {
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1000: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        }
      }
    };
    isCarousel && (carouselConfig.navigation = {
      nextEl: '.mt-reviews__carousel-arrow--next',
      prevEl: '.mt-reviews__carousel-arrow--prev',
    });

    if (isCarousel || window.innerWidth < 768) {
      _this.slider = new Swiper(_this.el.carousel, carouselConfig);
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        (_this.slider && !isCarousel) && _this.slider.destroy(true, true);
      } else {
        !_this.slider && (_this.slider = new Swiper(_this.el.carousel, carouselConfig));
      }
    });

    // See more (content)
    _this.el.seeMore.forEach(button => {
      const content = button.closest('.mt-review__content');
      button.addEventListener('click', e => {
        e.preventDefault();
        content.innerHTML = content.dataset.text;
      });
      button.classList.add('initialized');
    });

    // Load more (reviews)
    if (_this.el.loadMoreWrapper && _this.el.loadMore) {
      _this.el.loadMore.addEventListener('click', (e) => {
        e.preventDefault();

        const hiddenReviews = [..._this.el.carousel.querySelectorAll('.swiper-slide.hidden')];
        const count = Number(_this.el.wrapper.dataset.count);

        hiddenReviews.slice(0, count).forEach((review) => review.classList.remove('hidden'));

        if (hiddenReviews.length <= count) {
          _this.el.loadMoreWrapper.classList.add('hidden');
        }

        _this.el.sectionHeader && app.dl.customClick(_this.el.loadMore.innerText, { location: _this.el.sectionHeader?.innerText });
      });
    }
  }
}
window.app.productReviews.init();